// frontend/src/socket.js

import { io } from "socket.io-client";

//Read from .env at build time
const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const socket = io(BACKEND_URL, {
  autoConnect: false,
  transports: ["websocket"],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

socket.on("connect", () => {
  console.log("Socket connected:", socket.id);
});
socket.on("connect_error", (err) => {
  console.error("Socket connection error:", err);
});

export default socket;
